import { render, staticRenderFns } from "./height-weight-ruler.vue?vue&type=template&id=46531f76&scoped=true&"
import script from "./height-weight-ruler.vue?vue&type=script&lang=js&"
export * from "./height-weight-ruler.vue?vue&type=script&lang=js&"
import style0 from "./height-weight-ruler.vue?vue&type=style&index=0&id=46531f76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46531f76",
  null
  
)

export default component.exports